<template>
  <a-modal :title="`${itemName} 的图片`"
           :open="modal"
           :width="800"
           @cancel="cancelCk">
    <a-space class="nav-no-title">
      <a-select size="small"
                :options="siteList"
                v-model:value="site"
                @change="query"/>
      <a-button type="primary" @click="addCk" size="small">添加</a-button>
      <a-button @click="sortCk" size="small">排序</a-button>
    </a-space>

    <a-table size="small"
             :columns="columns"
             :data-source="source"
             :loading="loading"
             :pagination="false">
      <template v-slot:bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'type'">
          <a-tag v-if="record.type === 0" :bordered="false" color="green">图片</a-tag>
          <a-tag v-else :bordered="false" color="red">视频</a-tag>
        </template>

        <template v-else-if="column.dataIndex === 'link'">
          <a-image :src="record.link" :height="60"/>
        </template>

        <template v-else-if="column.dataIndex === 'act'">
          <a-space>
            <a-button @click="updCk(record)" size="small">编辑</a-button>
            <a-button danger @click="delCk(record)" size="small">删除</a-button>
          </a-space>
        </template>

        <template v-else>
          {{ record[column.dataIndex] }}
        </template>
      </template>
    </a-table>

    <template #footer></template>
  </a-modal>

  <add-thumb-modal ref="add" @refresh="query"/>

  <upd-thumb-modal ref="upd" @refresh="query"/>

  <sort-thumb-modal ref="sort" @refresh="query"/>
</template>

<script setup>
import {ref} from 'vue'
import {message, Modal} from 'ant-design-vue'
import axios from '@/axios'

import AddThumbModal from '@/views/item/AddThumb.vue'
import UpdThumbModal from '@/views/item/UpdThumb.vue'
import SortThumbModal from '@/views/item/SortThumb.vue'

const add = ref(null)
const upd = ref(null)
const sort = ref(null)
const source = ref([])
const modal = ref(false)
const loading = ref(false)
const site = ref(0)

const siteList = [
  {
    value: 0,
    label: '头图',
  }, {
    value: 1,
    label: '规则',
  }, {
    value: 2,
    label: '详情',
  }
]
const columns = [
  {
    key: 'id',
    title: 'ID',
    dataIndex: 'id',
  }, {
    key: 'type',
    title: '类型',
    dataIndex: 'type',
  }, {
    key: 'link',
    title: '缩略图',
    dataIndex: 'link',
  }, {
    key: 'act',
    title: '操作',
    dataIndex: 'act',
  }
]

let itemId = 0,
    itemName = ''

function query() {
  loading.value = true

  axios.get(`/item/${itemId}/thumb`, {
    params: {
      site: site.value
    }
  }).then((res) => {
    loading.value = false

    if (res.code === 1) {
      source.value = res.data
    }

    modal.value = true
  })
}

function addCk() {
  add.value.openCk(itemId, site.value)
}

function sortCk() {
  sort.value.openCk(`/item/${itemId}/thumb/sort?site=${site.value}`)
}

function updCk(record) {
  upd.value.openCk(itemId, site.value, record)
}

function delCk(record) {
  Modal.confirm({
    content: '确定删除吗？',
    okText: '删除',
    okType: 'danger',
    cancelText: '取消',
    onOk() {
      axios.post(`/item/${itemId}/thumb/${record.id}/state`, {
        state: 0
      }).then((res) => {
        if (res.code === 1) {
          message.success('操作成功')
          query()
        }
      })
    },
  })
}

function openCk(record) {
  itemId = record.id
  itemName = record.name
  site.value = 0
  query()
}

function cancelCk() {
  modal.value = false
}

defineExpose({openCk})
</script>

<style scoped>

</style>